import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import Button from "devextreme-react/button";
import axios from "axios";
import { GridLayout } from "../../common/GridLayout";
import TextBox from 'devextreme-react/text-box';
import { Popup, ScrollView,CheckBox } from "devextreme-react";
import { confirm } from 'devextreme/ui/dialog';

import DataGrid, {
    Column,
    Paging,
    FilterRow,
    FilterPanel,
    ColumnChooser,
    ColumnChooserSearch,
    FilterBuilderPopup,
    StateStoring,
    Editing,
    LoadPanel,
    Export,
    Pager,
    HeaderFilter,
    Selection,
    Sorting,
    Toolbar,
    Item,
} from 'devextreme-react/data-grid';
import { List as DxList, Item as DxItem } from 'devextreme-react/list';

import * as ReduxOidc from "redux-oidc";
import configuration from "../../configuration";
import Permission from "../Permission";
import ManageSettingsPopUp from "./ManageSettingsPopUp";


const filterBuilderPopupPosition = {
    of: window,
    at: "top",
    my: "top",
    offset: { y: 10 },
};
const RolesGrid = React.createRef();
const Roles = (props) => {
    let [globalRoles, setGlobalRoles] = useState([]);
    const [selectedRoleData, setSelectedRoleData] = useState({ key: "" });
    const [openRoleDialog, setOpenRoleDialog] = useState(false);
    const [roleState, setRoleState] = useState({
        name: "",
        id: "",
        normalizedName: "",
    });
    const [roleName, setRoleName] = useState("");
    const [role, setRole] = useState("");
    const [deleteRoleDialog, setDeleteRoleDialog] = useState(false);
    const [roleToPermissionDialog, setRoleToPermissionDialog] = useState(false);
    const [rolePermissionsByName, setRolePermissionsByName] = useState([]);
    const [rolePermissions, setRolePermissions] = useState([]);
    const [rolePermissionsUpdated, setRolePermissionsupdated] = useState([]);
    const [stateSettingsPopUp, setStateSettingsPopUp] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isCheckboxDisable, setIsCheckboxDisable] = useState(false);
    let accessToken = props.oidc.user.access_token;
    const loadGlobalRoles = () => {
        RolesGrid.current.instance().beginCustomLoading();
        axios
            .get(`${window._env_.REACT_APP_AUTH_URL}/${data.idp.globalRoles}`)
            .then((res) => {
                setGlobalRoles(res.data);
                RolesGrid.current.instance().endCustomLoading();
                loadRolePermissions();
            })
            .catch((err) => {
                console.log(err, "error in loading Roles");
                RolesGrid.current.instance().endCustomLoading();
            });
    };
    useEffect(() => {
        loadGlobalRoles();
    }, []);
    const renderAssignedPermissions = (data) => {
        return data.data.permissions.map(permission => permission.title).join(', ');
    };
    const onSelectionChanged = (e) => {
        let role = e?.selectedRowsData?.length == 1 ? e?.selectedRowsData[0] : {};
        setSelectedRoleData(role);
    };
    const roleDialog = () => {
        setOpenRoleDialog(true);
    };
    const hideInfo = () => {
        setOpenRoleDialog(false);
    };
    const onInputChange = (e) => {
        setRoleState({ ...roleState, name: e.value });
    };
    const saveRoleInIdp = (e) => {
        
        if (roleState.id === "") {
            axios
                .post(
                    `${window._env_.REACT_APP_AUTH_URL}/${data.idp.addNewRole}`,
                    roleState
                )
                .then((res) => {
                    loadGlobalRoles();
                    closeRoleDialog();
                })
                .catch((err) => {
                    console.log(err, "error in loading Roles");
                });
        } else {
            var updateRoleRequest = {
                name: roleState.name,
                id: roleState.id,
                normalizedName: roleState.name.toUpperCase(),
            };
            axios
                .post(
                    `${window._env_.REACT_APP_AUTH_URL}/${data.idp.updateGlobalRole}`,
                    updateRoleRequest
                )
                .then((res) => {
                    setRoleState({
                        name: "",
                        id: "",
                        normalizedName: "",
                    });
                    closeRoleDialog();
                    loadGlobalRoles();
                })
                .catch((err) => {
                    console.log(err, "error in updating Roles");
                });
        }
    };
    const getRoleById = () => {
        let roleName = selectedRoleData.key;
        axios
            .get(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetGlobalRoleById}?roleName=${roleName}`
            )
            .then((res) => {
                
                setRoleState(res.data);
                setOpenRoleDialog(true);
            })
            .catch((err) => {
                console.log(err, "error in loading Roles");
            });
    };
    const closeRoleDialog = (e) => {
        setOpenRoleDialog(false);
        setRoleState({
            name: "",
            id: "",
            normalizedName: "",
        });
    };
    const onAllowPermissionToRole = () => {
        let role = selectedRoleData;
        setRole(role.key);
        getpermissionsByRoleName(role.key);
    };
    const openDialogForDeleteRole = () => {
        let result = confirm(`<i>Are your sure you want to delete <b>${selectedRoleData.key}<b> record?</i>`, "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                RolesGrid.current.instance().beginCustomLoading("Deleting");
                var deletedRole = {
                    name: selectedRoleData.key,
                };
                axios
                    .post(
                        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.deleteGlobalRole}`,
                        deletedRole
                    )
                    .then((result) => {
                        RolesGrid.current.instance().endCustomLoading();
                        loadGlobalRoles();
                    })
                    .catch((err) => {
                        console.log(err, "error in delete user");
                        RolesGrid.current.instance().endCustomLoading();
                    });
            }
        });
    };
    const getpermissionsByRoleName = (roleName) => {
        axios
            .get(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetPermissionsByRoleName}?roleName=${roleName}`
            )
            .then((res) => {
                rolePermissions.forEach((element) => {
                    element.permissions.forEach((p) => {
                        if (res.data.length>0) {
                            res.data.forEach((r) => {
                                r.permissions.forEach((perm) => {
                                    let key = element.key + p.title;
                                    if (perm.title === key) {
                                        element.isSelected = true;
                                        p.isChecked = true;
                                    }
                                });
                            });
                        }
                        else {
                            element.isSelected = false;
                            p.isChecked = false;
                        }
                    });
                });
                setRolePermissionsupdated(rolePermissions);
            }).finally(() => setRoleToPermissionDialog(true))
            .catch((err) => {
                console.log(err, "error in loading!");
            });
    };
    const onManageSettings = (e) => {
        setRole(e.key);
        setStateSettingsPopUp(!stateSettingsPopUp);
    };
    const handleClosePopUpCallback = (ChildData) => {
        setStateSettingsPopUp(ChildData);
    };

    const closeRoleToPermissionDialog = () => {
        loadGlobalRoles();
        refreshToken();
        setRoleToPermissionDialog(false);
    };
    const loadRolePermissions = () => {
        setLoading(true);
        axios
            .get(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetRolePermissions}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                setLoading(false);
                setRolePermissions(res.data);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err, "Error in loading Roles");
            });
    };
    const onSearchPermissions = (e) => {
        let searchtext = e.event.target.value.toString().toLowerCase();
        let filterPermissions = [];
        if (e.event.target.value !== "") {
            filterPermissions = rolePermissions.filter((searchPerm) =>
                searchPerm.key.toLowerCase().includes(searchtext)
            );
            setRolePermissionsupdated(filterPermissions);
        } else {
            if (e.event.target.value === "") {
                setRolePermissionsupdated(rolePermissions);
            }
        }
    };
    const onSelectPermission = (e, p, key) => {
        p.isChecked = e.value;
        setIsCheckboxDisable(true);
        let perms = [];
        rolePermissionsUpdated.forEach((resetPerm) => {
            resetPerm.permissions.forEach((permission) => {
                if (permission.isChecked) {
                    perms.push(`${resetPerm.key + permission.title}`);
                }
            });
        });

        axios
            .post(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.AddRolePermissions}?roleName=${role}&groupName=${key}`,
                perms
            )
            .then((resp) => {
                // refreshToken();
                let getPermissionFromStore = props.ReceiptReducer.rolePermissions;
                Object.entries(getPermissionFromStore).map(([groupName, values]) => {
                    if (p.isChecked === true) {
                        if (groupName === key) {
                            values.push(p.title);
                        }
                    } else {
                        if (groupName === key) {
                            let permIndex = values.findIndex((item) => item === p.title);
                            if (permIndex > -1) {
                                values.splice(permIndex, 1);
                            }
                        }
                    }
                });
                setIsCheckboxDisable(false);
                loadGlobalRoles();
            })
            .catch((err) => {
                console.log(err);
                setIsCheckboxDisable(false);
            });
    };
    const refreshToken = (e) => {
        var userManager = ReduxOidc.createUserManager(configuration.config);

        userManager
            .signinSilent()
            .then((res) => {
                console.log("done signinSilent");
            })
            .catch((error) => {
                console.error(error);
            });
    };
    return (
        <div style={{ overflowY: 'hidden',marginTop:'10px' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                dataSource={globalRoles}
                showBorders={true}
                className="usersecuritygridstyle"
                hoverStateEnabled={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                rowAlternationEnabled={true}
                columnAutoWidth={true}
                ref={RolesGrid}
                keyExpr={"key"}
                onSelectionChanged={(e) => onSelectionChanged(e)}
                showRowLines={true}
                scrolling={{ mode: "standard" }}
                showColumnLines={false}>
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={900}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Sorting mode="multiple" />
                <LoadPanel enabled={true} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <FilterBuilderPopup position={filterBuilderPopupPosition} />
                <Export enabled={true} allowExportSelectedData={true} text="Export" />
                <Selection mode="single" allowSelectAll={false} />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                    showNavigationButtons={true}
                />
                <Editing
                    mode="row"
                    useIcons={true}
                    allowUpdating={false}
                    allowDeleting={false} />
                <Column dataField="key" caption="Role Name"></Column>
                <Column dataField="permarray" wordWrapEnabled={true} cellRender={renderAssignedPermissions} caption="Assigned Permissions"></Column>
                <Toolbar>
                    <Item location="before">
                        <Button
                            onClick={roleDialog}
                            text="Add Role"
                            type="default"
                            stylingMode="contained"
                            className="margin-right">
                        </Button>
                    </Item>
                    <Item location="before">
                        <Button
                            onClick={getRoleById}
                            text="Edit"
                            type="default"
                            stylingMode="contained"
                            className="margin-right"
                            disabled={!selectedRoleData.key}
                        >
                        </Button>
                    </Item>
                    <Item location="before">
                        <Button
                            onClick={openDialogForDeleteRole}
                            text="Delete"
                            type="default"
                            stylingMode="contained"
                            className="margin-right"
                            disabled={!selectedRoleData.key}
                        >
                        </Button>
                    </Item>
                    <Item location="before">
                        <Button
                            onClick={onAllowPermissionToRole}
                            text="Manage Permission"
                            type="default"
                            stylingMode="contained"
                            className="margin-right"
                            disabled={!selectedRoleData.key}
                        >
                        </Button>
                    </Item>
                    <Item location="before">
                        <Button
                            onClick={onManageSettings}
                            text="Manage Settings"
                            type="default"
                            stylingMode="contained"
                            className="margin-right"
                            disabled={!selectedRoleData.key}
                        >
                        </Button>
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <Popup
                visible={roleToPermissionDialog}
                onHiding={() => closeRoleToPermissionDialog()}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={'Add Permissions To ' + role}
                container="#root"
                width="100vw"
                height="100vh"
            >
                <ScrollView height="100%" width="100%">
                    <div className="row">
                     <Permission rolePermissions={rolePermissionsUpdated} popupOpen={roleToPermissionDialog} role={role} />
                    </div>
                </ScrollView>
            </Popup>
            {
                openRoleDialog &&
                <Popup
                    id="accc"
                    container="#root"
                    visible={openRoleDialog}
                    onHiding={hideInfo}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    dragEnabled={false}
                    title="Select User Role"
                    width="30vw"
                    height="30vh"
                    fullScreen={false}
                >
                    <form>
                        <TextBox
                            id="role"
                            label="Enter RoleName"
                            labelMode="static"
                            stylingMode='outlined'
                            name="name"
                            value={roleState.name}
                            onValueChanged={(e) => onInputChange(e)}
                        />
                        <div className="d-flex align-items-center mt-4" style={{ marginTop:'10px' }}>
                            <Button
                                text="Save Role"
                                type="default"
                                onClick={(e) => saveRoleInIdp(e)}
                            />
                            <Button
                                text="Cancel"
                                className="ml-3 mb-0"
                                onClick={(e) => closeRoleDialog(e)}
                            />
                        </div>
                    </form>
                </Popup>
            }
            {stateSettingsPopUp && (
                <ManageSettingsPopUp
                    roleName={selectedRoleData.key}
                    visibility={stateSettingsPopUp}
                    parentCallback={handleClosePopUpCallback}
                ></ManageSettingsPopUp>
            )}
        </div>
    )
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Roles);